
import Api from './../abstract'
import { APP_TOKEN_NAME } from '@/config'
import { getQueryStringPhase2 } from '@/utils'

export let GET_LIST_PARENT_APPROVE = (params, successCallback, errorCallback) => {
    let filter = params.payload.filter || null
    let sort = params.payload.sort || null
    let page = params.payload.page || null
    let url = `${process.env.VUE_APP_API_URL}/admin/list-approve?${getQueryStringPhase2(filter, sort, page)}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };

    return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let REJECT_PARENT_USER = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/parents/${params.payload.parent_id}/reject`
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    }
    let data = params.payload.data
    return new Api(url, 'delete', successCallback, errorCallback, {headers, data})
}

export let UPDATE_APPROVE_STUDENT = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/student/${params.payload.data.id}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };
    let data = params.payload.data
    return new Api(url, 'put', successCallback, errorCallback, { headers, data })
};
export let DETAIL_APPROVE_STUDENT = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/student/${params.payload.student_id}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };
    return new Api(url, 'get', successCallback, errorCallback, { headers })
};
export let GET_LIST_APPROVE_STUDENT = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/student/approve`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };
    return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let REJECT_STUDENT = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/student/${params.payload.student_id}/reject`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };
    let data = params.payload.data
    return new Api(url, 'delete', successCallback, errorCallback, { headers, data })
};

export let SENT_EMAIL_INFO_STUDENT = (params, successCallback, errorCallback) => {
    let idStudent = params.payload.idStudent
    let url = `${process.env.VUE_APP_API_URL}/admin/student/${idStudent}/mail`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };
    return new Api(url, 'get', successCallback, errorCallback, { headers })
};
export let LIST_STUDENT_NEW = (params, successCallback, errorCallback) => {
    let filter = params.payload.filter || null
    let sort = params.payload.sort || null
    let page = params.payload.page || null
    let url = `${process.env.VUE_APP_API_URL}/admin/notifications/new-student?${getQueryStringPhase2(filter, sort, page)}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };
    return new Api(url, 'get', successCallback, errorCallback, { headers })
};
export let ON_SHOWED_NEW_STUDENT = (params, successCallback, errorCallback) => {
    let idStudent = params.payload.idStudent
    let url = `${process.env.VUE_APP_API_URL}/admin/notifications/${idStudent}/new-student`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };
    return new Api(url, 'patch', successCallback, errorCallback, { headers })
};

